import React, { useContext, useEffect, useState } from "react";
import DynamicHtml from "../CommonComponent/DynamicHtml";
import DynamicCell from "../CommonComponent/DynamicCell";
import PrescriberNoteNoDetailsDisplay from "./PrescriberNoteNoDetailsDisplay";
import PrescriberNoteTableCell from "./PrescriberNoteTableCell";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CommonService, DynamicDataService } from "@services";
import { ConfigurationContext } from "../../../contexts/Configuration";
import { SearchContext } from "../../../contexts/Search";

const PrescriberNotesHorizontalDisplay = ({
  prescriberNoteResponse,
  coverageFinderPrescriberNotesFields,
  section,
  contingentDataField,
  row,
}) => {
  const matchesMobileWidth = useMediaQuery("(max-width:1032px)");
  const { appliedConfiguration, settings } = useContext(ConfigurationContext);
  const { benefitType } = useContext(SearchContext);
  const benefitTypeId = benefitType == "Pharmacy" ? 2 : 1;
  const prescriberNoteLogic = appliedConfiguration.coverageFinderPrescriberNoteLogics.filter(
    (obj) => obj.benefitTypeId === benefitTypeId
  )[0];
  const CUSTOM_VALUE_DATAFIELD = "_dataFieldsWithCustomValue";
  const [showDataSource, setShowDataSource] = useState(false);
  useEffect(() => {
    if (settings?.findIndex((setting) => setting.settingId === 85 && setting.isEnabled === true) > -1) {
      setShowDataSource(true);
    }
  }, [settings]);
  const prescriberNoteResponseLowerCase = prescriberNoteResponse?.map((item) =>
    Object.keys(item).reduce((acc, key) => {
      acc[key.toLowerCase()] = item[key];
      return acc;
    }, {})
  )[0];
  const noteFields = coverageFinderPrescriberNotesFields.filter((obj) => obj.prescriberNoteSectionId === section.id);

  function renderCustomValue(value) {
    return (
      <div
        className={showDataSource ? "norstella-cf-dataSource" : "norstella-cf-customValue"}
        dangerouslySetInnerHTML={{
          __html: CommonService.sanitizeHTML(CommonService.htmlDecode(value ?? "")),
        }}
      />
    );
  }

  const renderDynamicCellData = function (field) {
    if (field.coverageContingentData) {
      const isCustomValue =
        row[CUSTOM_VALUE_DATAFIELD]?.split(",")?.findIndex((item) => item === contingentDataField.toLowerCase()) > -1;
      const { rowValue, iconPath, displayPrefix, altText } = DynamicDataService.extractDynamicRowData(
        row[contingentDataField]
      );
      if (isCustomValue) return renderCustomValue(rowValue);

      return <DynamicCell rowValue={rowValue} iconPath={iconPath} displayPrefix={displayPrefix} altText={altText} />;
    } else if (field.status) {
      const status = row["Status"] ?? row["majority_Status"] ?? "";
      return status;
    } else {
      return "";
    }
  };

  const sectionFieldDataExists = (field) => {
    if (!field) {
      return false;
    }

    if (prescriberNoteResponseLowerCase && CommonService.objectHasProperty(prescriberNoteResponseLowerCase, field.dataField.toLowerCase())) {
      return (
        prescriberNoteResponseLowerCase[field.dataField.toLowerCase()] !== "" &&
        prescriberNoteResponseLowerCase[field.dataField.toLowerCase()] !== null &&
        prescriberNoteResponseLowerCase[field.dataField.toLowerCase()] !== undefined
      );
    } else {
      return (
        row[field.dataField] !== "" &&
        row[field.dataField] !== null &&
        row[field.dataField] !== undefined
      );
    }
  };

  const showSectionField = (field, checkSectionFieldLogic, hideSectionFieldIfEmpty) => {
    return (
      sectionFieldDataExists(field) ||
      (checkSectionFieldLogic &&
        prescriberNoteLogic?.hideSectionFieldIfNoData?.toLowerCase() === hideSectionFieldIfEmpty) ||
      field.coverageContingentData ||
      field.status
    );
  };

  const getTableCellData = (field, headerindex) => {
    if (field.coverageContingentData || field.status) {
      return renderDynamicCellData(field);
    } else if (sectionFieldDataExists(field)) {
      return (
        <PrescriberNoteTableCell
          field={field}
          prescriberNoteResponseLowerCase={prescriberNoteResponseLowerCase}
          resultRow={row}
          cssClassName={`norstella-cf-NoteCell norstella-cf-tableNoteCell${headerindex}`}
        />
      );
    } else {
      return <PrescriberNoteNoDetailsDisplay isSectionField={true} />;
    }
  };

  if (!noteFields || noteFields.length === 0) {
    return <PrescriberNoteNoDetailsDisplay isSectionField={false} />;
  }
  return (
    <div className="norstella-cf-flexAlignResponsive" part="cfDivDisplayCoverage">
      <TableContainer part="cfNoteHorizonTableContainer" className="norstella-cf-noteHorizonTableContainer">
        <Table className="norstella-cf-prescriberNoteContainer" part="cfNoteContainer">
          {noteFields.some((field) => showSectionField(field, true, "no")) ? (
            <>
              <TableHead part="cfNoteHorizonTableHead" className="norstella-cf-noteHorizonTableHead">
                <TableRow className="norstella-cf-tableHeaderRow" part="cfTableHeaderRow">
                  {noteFields.map(
                    (headCell, index) =>
                      showSectionField(headCell, true, "no") && (
                        <TableCell
                          key={headCell.id}
                          className={`norstella-cf-tableHeaderCell norstella-cf-tableHeaderCell${index}`}
                          part="cfTableHeaderCell"
                        >
                          <DynamicHtml part="cfTableHeaderCellLabel" input={headCell.title} type="label" />
                        </TableCell>
                      )
                  )}
                </TableRow>
              </TableHead>
              <TableBody part="cfNoteHorizonTableBody" className="norstella-cf-noteHorizonTableBody">
                <TableRow part="cfNoteHorizonTableRow" className="norstella-cf-noteHorizonTableRow">
                  {noteFields.map(
                    (field, headerindex) =>
                      showSectionField(field, true, "no") && (
                        <TableCell
                          className={`norstella-cf-tableNoteBodyCell norstella-cf-tableNoteBodyCell${headerindex}`}
                          part="cfTableNoteBodyCell"
                          key={field.id}
                          scope={headerindex === 0 ? "row" : ""}
                        >
                          {getTableCellData(field, headerindex)}
                        </TableCell>
                      )
                  )}
                </TableRow>
              </TableBody>
            </>
          ) : (
            <TableRow part="cfNoteVerticalTableRow" className="norstella-cf-noteVerticalTableRow">
              <TableCell
                colSpan={matchesMobileWidth ? 2 : 3}
                style={{ textAlign: "center" }}
                part="cfNoteNoCriteria"
                className="norstella-cf-noteNoCriteria"
              >
                <PrescriberNoteNoDetailsDisplay isSectionField={false} />
              </TableCell>
            </TableRow>
          )}
        </Table>
      </TableContainer>
    </div>
  );
};

export default PrescriberNotesHorizontalDisplay;
